function handleLoaded($state) {
    if ($state) {
        $state.loaded();
    } else {
        if(this && this.$refs && this.$refs.infiniteLoading){
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
        }
    }
}

function handleComplete($state) {
    if ($state) {
        $state.complete();
    } else {
        if(this && this.$refs && this.$refs.infiniteLoading){
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
        }
    }
}

function buildOptions(options) {
    let base = {
        responseLength: 0,
        isComplete: false,
        onLoad: null,
        onComplete: null,
        onEmpty: null
    };

    return Object.assign({}, base, options);
}

export default {
    methods: {
        handleInfinite($state, options) {
            options = buildOptions(options);

            if (options.responseLength) {
                if (typeof options.onLoad === 'function') {
                    options.onLoad();
                }
                
                handleLoaded($state);

                if (options.isComplete) {
                    if (typeof options.onComplete === 'function') {
                        options.onComplete();
                    }
                    handleComplete($state);
                }
            } else {
                if (typeof options.onEmpty === 'function') {
                    options.onEmpty();
                }
                handleComplete($state);
            }
        },

        infiniteFilterChange(onChange) {
            if (typeof onChange === 'function') {
                onChange();
            }

            this.$nextTick(() => {
                if (this.$refs.infiniteLoading) {
                    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
                }
            });
        }
    }
}